import React from 'react'
import PropTypes from 'prop-types'
import TopBanner from './components/TopBanner'
import styled from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import SelectPaymentPlan from './components/SelectPaymentPlan'
import EngageSection from './components/EngageSection'
import SelectPlan from './components/SelectPlan'
import ModalContext from 'components/Context/ModalContext'
import ClassSizePopup from './components/ClassSizePopup'
import ClassesNumberPopup from './components/ClassesNumberPopup'
import SchoolsNumberPopup from './components/SchoolsNumberPopup'
import CheckoutFormPopup from './components/Checkout/CheckoutFormPopup'
import SelectPaymentPlanPopup from './components/SelectPaymentPlanPopup'
import CardSuccessPopup from './components/CardSuccessPopup'
import InvoiceSuccessPopup from './components/InvoiceSuccessPopup'
import SelectPaymentTypePopup from './components/SelectPaymentTypePopup'
import SubscribedHeading from './components/SubscribedHeading/SubscribedHeading'

export const Wrapper = styled.div`
  background-color: white;
`

class Subscription extends React.Component {
  static propTypes = {
    parent: PropTypes.bool
  }

  constructor (props) {
    super(props)
    this.state = {
      selectedProduct: null
    }
  }

  componentDidMount () {}

  async selectProduct (p) {
    await this.setState({
      selectedProduct: p
    })
    this.props.modal.closeAll()
    this.displaySelectPaymentPlanPopup()
  }

  async selectPlan (p) {
    await this.setState({
      selectedPlan: p
    })
    this.props.modal.closeAll()
    this.displaySelectPaymentTypePopup()
  }

  displaySelectPaymentPlanPopup () {
    if (this.state.selectedProduct && this.state.selectedProduct.plans) {
      this.props.modal.open(
        <SelectPaymentPlanPopup
          onSelect={this.selectPlan.bind(this)}
          plans={this.state.selectedProduct.plans}
          onCancel={this.props.modal.closeAll}
        />
      )
    }
  }

  displaySelectClassSizePopup () {
    this.props.modal.open(
      <ClassSizePopup
        products={this.props.products}
        onCancel={this.props.modal.closeAll}
        onSubmit={this.selectProduct.bind(this)}
      />
    )
  }

  displaySelectPaymentTypePopup () {
    this.props.modal.closeAll()
    if (this.state.selectedPlan.interval === 'month' || this.props.parent) {
      this.displayCardPaymentPopup()
      return
    }
    this.props.modal.open(
      <SelectPaymentTypePopup
        plan={this.state.selectedPlan}
        product={this.state.selectedProduct}
        onCancel={this.props.modal.closeAll}
        onCardSelect={this.displayCardPaymentPopup.bind(this)}
        onInvoiceSelect={this.onRequestInvoice.bind(this)}
      />
    )
  }

  displaySelectClassesNumberPopup () {
    this.props.modal.open(
      <ClassesNumberPopup
        countryCode={this.props.countryCode}
        onCancel={this.props.modal.closeAll}
        onSubmit={this.onRequestInvoice.bind(this)}
      />
    )
  }

  displaySelectSchoolsNumberPopup () {
    this.props.modal.open(
      <SchoolsNumberPopup
        onCancel={this.props.modal.closeAll}
        onSubmit={this.onRequestInvoice.bind(this)}
      />
    )
  }

  handleCheckoutSuccess () {
    this.props.modal.closeAll()
    this.props.modal.open(
      <CardSuccessPopup onCancel={this.props.modal.closeAll} />
    )
  }

  onRequestInvoice (questions, plan) {
    let planToSend = {}
    if (plan) {
      planToSend = { ...plan }
      delete planToSend.__typename
    }
    this.props.modal.closeAll()
    this.props.modal.open(
      <InvoiceSuccessPopup onCancel={this.props.modal.closeAll} />
    )
    this.props.onRequestInvoice(questions, planToSend)
  }

  displayCardPaymentPopup () {
    this.props.modal.open(
      <CheckoutFormPopup
        parent={this.props.parent}
        onCancel={this.props.modal.closeAll}
        handleStripeToken={this.props.handleStripeToken}
        plan={this.state.selectedPlan}
        product={this.state.selectedProduct}
        onSuccess={this.handleCheckoutSuccess.bind(this)}
        getDiscount={this.props.getDiscount}
        subscription={this.props.currentSubscription}
      />
    )
  }

  renderPlanSelection () {
    let plans
    const { products } = this.props
    if (this.props.parent) {
      if (!products || (products && products.length === 0)) {
        return null
      }
      plans = products[0].plans
    }
    const isSubscribed = this.props.currentSubscription && new Date(this.props.currentSubscription.subscriptionEndDate) > Date.now()
    return this.props.parent ? (
      <SelectPaymentPlan
        plans={plans}
        onSubmit={async p => {
          await this.setState({
            selectedProduct: products[0]
          })
          this.selectPlan(p)
        }}
      />
    ) : (
      <SelectPlan
        isSubscribed={isSubscribed}
        onSelectOneClass={this.displaySelectClassSizePopup.bind(this)}
        onSelectMultipleClasses={this.displaySelectClassesNumberPopup.bind(
          this
        )}
        onSelectWholeSchool={this.displaySelectClassesNumberPopup.bind(this)}
        onSelectMultipleSchools={this.displaySelectSchoolsNumberPopup.bind(
          this
        )}
      />
    )
  }

  render () {
    return (
      <Wrapper>
        {this.props.currentSubscription ? (
          <SubscribedHeading
            parent={this.props.parent}
            subscription={this.props.currentSubscription}
          />
        ) : (
          <TopBanner parent={this.props.parent} />
        )}
        {/* this.renderPlanSelection() */}
        <EngageSection />
        {/* this.renderPlanSelection() */}
      </Wrapper>
    )
  }
}

export default props => (
  <ModalContext.Consumer>
    {modal => <Subscription {...props} modal={modal} />}
  </ModalContext.Consumer>
)
